import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, FreeMode } from "swiper";
import styles from "./showcase.module.scss";
import NftCard from "./NftCard";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import launchPadsServices from "@/network/launchpads/services";
import { useQuery } from "@tanstack/react-query";
import ReactLoading from "react-loading";

const Launchpad = () => {
  const { data: dataLaunchPads, isLoading } = useQuery({
    queryKey: ["fetchListLaunchPads"],
    queryFn: () => launchPadsServices.fetchListLaunchPads("ALL"),
  });

  return (
    <div className={styles.swiper_container}>
      {!isLoading && dataLaunchPads && dataLaunchPads.data ? (
        dataLaunchPads.data.length > 0 ? (
          <Swiper
            className={styles.swiper}
            spaceBetween={20}
            navigation={true}
            freeMode={true}
            breakpoints={{
              0: {
                slidesPerView: 1.5,
                slidesPerGroup: 1.5,
              },
              500: {
                slidesPerView: 2,
                slidesPerGroup: 2,
              },
              700: {
                slidesPerView: 3,
                slidesPerGroup: 3,
              },
              900: {
                slidesPerView: 4,
                slidesPerGroup: 4,
              },
              1100: {
                slidesPerView: 5,
                slidesPerGroup: 5,
              },
              1300: {
                slidesPerView: 6,
                slidesPerGroup: 6,
              },
            }}
            modules={[FreeMode, Navigation]}
          >
            {dataLaunchPads.data.map((launchPad, idx) => (
              <SwiperSlide className={styles.nft_item} key={idx}>
                <NftCard {...launchPad} />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="w-full font-bold mt-12 mb-4 text-center text-[18px]">
            No live launchpad!
          </div>
        )
      ) : (
        <div className="my-10 flex items-center justify-center">
          <ReactLoading
            type="spin"
            color="rgba(0, 0, 0, 0.7)"
            height={32}
            width={32}
          />
        </div>
      )}
    </div>
  );
};

export default Launchpad;
